module.exports = __webpack_public_path__ + "static/media/logo_tlatelolco_01.12f0197e.svg";